import {useCallback} from 'react';
import axiosInstance from "../../../../../axiosInstance";

const usePostProductRegenerate = () => {
  return useCallback(({productId}) => {
    const baseUrl = window.localStorage.getItem("BaseURL")
    const endpoint = `/services/projectmanagement/api/products/regenerate-image`
    const fullUrl = baseUrl + endpoint;

    return new Promise((resolve, reject) => {
      axiosInstance.post(fullUrl, {
        baseProductId: productId
      })
        .then((res) => resolve(res.data))
        .catch(reject)
    })
  }, [])
};

export default usePostProductRegenerate;
